import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Row, Form, FormGroup, Input, Col, Label, Button } from 'reactstrap'
import { handleLoadInvoiceDetails } from '../../actions/reconciliationTypes'
import LoadingSpinner from '../../Shared/LoadingSpinner'
import PageContainer from '../../Shared/LayoutComponents/PageContainer'
import PageHeading from '../../Shared/LayoutComponents/PageHeading'
import LoadedInvoiceDetails from './LoadedInvoiceDetails'

export const ReUpload = (props) => {
  const [invoiceNumber, setInvoiceNumber] = useState('')

  return (
    <PageContainer>
      <Row>
        <PageHeading fullWidth={true}>Re-Upload Client Data</PageHeading>
      </Row>
      <Form>
        <FormGroup row>
          <Label for="InvoiceNumber" sm={2} size="lg">
            Invoice Number
          </Label>
          <Col sm={6}>
            <Input
              type="email"
              name="InvoiceNumber"
              value={invoiceNumber}
              id="InvoiceNumber"
              onChange={(e) => setInvoiceNumber(e.target.value)}
            />
          </Col>
          <Col sm={2}>
            <Button color="primary" onClick={() => props.handleLoadInvoiceDetails(invoiceNumber)}>
              Load
            </Button>
          </Col>
        </FormGroup>
        {props.loadingInvoice ? <LoadingSpinner /> : props.loadedInvoice && <LoadedInvoiceDetails />}
      </Form>
    </PageContainer>
  )
}

const mapStateToProps = (state) => ({
  loadedInvoice: state.recon.loadedInvoice,
  loadingInvoice: state.recon.loadingInvoice,
})

const mapDispatchToProps = {
  handleLoadInvoiceDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReUpload)
